import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import TenderLostEvent from './TenderLostEvent';
import CommentEvent from './CommentEvent';
import NewTendersEvent from "./NewTendersEvent";
import TenderWonEvent from "./TenderWonEvent";
import RepeatedTenderEvent from "./RepeatedTenderEvent";
import './EventsFeed.css';

class EventsFeed extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        events: []
    };

    clearEvents() {

    }

    render() {
        const props = this.props, state = this.state;

        let content = state.isLoading
            ? (
                <div className="btn-loading widget-notifications-item">
                    Загружается...
                </div>
            ) : (
                <div>
                    <TenderLostEvent/>
                    <CommentEvent/>
                    <NewTendersEvent/>
                    <TenderWonEvent/>
                    <RepeatedTenderEvent/>
                    <a href="#" className="widget-more-link">ПОКАЗАТЬ СТАРЫЕ СОБЫТИЯ...</a>
                </div>
            );

        content = <div className="p-a-2">
            Страница находится в разработке...
        </div>;

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <i className="page-header-icon ion-ios-pulse-strong"/>Лента событий
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel">
                            {/*<div className="panel-heading">*/}
                                {/*<span className="panel-title">&nbsp;</span>*/}
                                {/*<div className="panel-heading-controls">*/}
                                    {/*<button className="btn btn-xs btn-outline btn-outline-colorless"*/}
                                            {/*onClick={this.clearEvents}>*/}
                                        {/*<i className="fa fa-remove"/> Очистить*/}
                                    {/*</button>*/}
                                    {/*<Link to="/profile/notifications" className="btn btn-xs btn-info">*/}
                                        {/*<i className="fa fa-cog"/> Настроить*/}
                                    {/*</Link>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EventsFeed;


// WEBPACK FOOTER //
// ./src/pages/EventsFeed/EventsFeed.js